export const HS_INTERNAL_USER_ID = 'hs_internal_user_id';
export const HS_INVITE_STATUS = 'hs_invite_status';
export const HS_MANAGER = 'hs_manager';
export const HS_STANDARD_TIME_ZONE = 'hs_standard_time_zone';
export const HS_TIMEZONE_AUTO_UPDATE_ENABLED = 'hs_timezone_auto_update_enabled';
export const USER_OBJECT_TYPE_ID = '0-115';
export const EMAIL_PROPERTY = 'hs_email';
export const USER_ID_PROPERTY = 'hs_internal_user_id';
export const NAME_PROPERTY = 'hs_searchable_calculated_name';
export const FIRST_NAME_PROPERTY = 'hs_given_name';
export const LAST_NAME_PROPERTY = 'hs_family_name';
export const JITA_PROPERTY = 'hs_hubspot_jita_user';
export const IS_VIRTUAL_USER = 'hs_is_mam_user';
export const IS_BOT_PROPERTY = 'hs_is_bot';
export const ACCESS_PROPERTY = 'hs_access';
export const IS_APP_SERVICE_ACCOUNT = 'hs_is_app_service_account';
export const IS_WORK_AGENT = 'hs_is_work_agent';